import { ReactNode } from "react"

import { classNames } from "../../../../lib/classNames"

export interface TablePlaceholderProps {
  children: ReactNode
  className?: string
}

export function TablePlaceholder({
  children,
  className,
}: TablePlaceholderProps) {
  return (
    <div
      className={classNames(
        "-translate-y-1/8 sticky inset-x-0 flex h-full flex-col items-center justify-center gap-y-2 p-10",
        className
      )}
    >
      {children}
    </div>
  )
}
